export const DATA_SECURITY_URL =
    'https://community.mews.com/product-best-practice-7/stay-secure-and-protect-yourself-against-phishing-attempts-1571';

export const TRUSTED_DEVICES_URL =
    'https://help.mews.com/s/article/How-to-add-a-new-trusted-device-with-Trusted-Device-Authorization-in-Mews-Operations-1';

export const TWO_FA_URL = 'https://help.mews.com/s/article/Set-up-Two-Factor-Authentication-2FA-via-email';
